import React from 'react';

function normalizeKind(link) {
  const raw = String(link?.kind || link?.label || '').toLowerCase().trim();
  if (!raw) return 'website';
  if (raw === 'x' || raw === 'twitter/x') return 'twitter';
  if (raw === 'official website' || raw === 'website' || raw === 'site' || raw === 'web') {
    return 'website';
  }
  if (raw === 'yt' || raw === 'you tube') return 'youtube';
  if (raw === 'ig') return 'instagram';
  if (raw === 'fb') return 'facebook';
  if (raw === 'tt') return 'tiktok';
  if (raw === 'last.fm' || raw === 'last-fm') return 'lastfm';
  return raw.replace(/\s+/g, '');
}

function IconWebsite() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" />
    </svg>
  );
}

function IconYouTube() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
      <path d="M23.5 6.2a3 3 0 0 0-2.1-2.1C19.2 3.5 12 3.5 12 3.5s-7.2 0-9.4.6A3 3 0 0 0 .5 6.2C0 8.4 0 12 0 12s0 3.6.5 5.8a3 3 0 0 0 2.1 2.1c2.2.6 9.4.6 9.4.6s7.2 0 9.4-.6a3 3 0 0 0 2.1-2.1C24 15.6 24 12 24 12s0-3.6-.5-5.8zM9.5 15.6V8.4L15.8 12l-6.3 3.6z" />
    </svg>
  );
}

function IconTwitch() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
      <path d="M2.9 0 0.3 4.3v17.1h5.1V24h3.4l3.4-2.6h4.3L23.7 16V0H2.9zm17.1 15.4-2.6 2.6h-4.3l-3.4 2.6v-2.6H3.4V1.7h16.6v13.7zM11.1 7.7H9v6.9h2.1V7.7zm5.1 0h-2.1v6.9H16.2V7.7z" />
    </svg>
  );
}

function IconInstagram() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="5" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function IconTwitter() {
  return (
    <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" aria-hidden="true">
      <path d="M18.2 2H21l-6.6 7.5L22 22h-6.2l-4.9-6.4L5.3 22H2.5l7-8L2 2h6.4l4.4 5.8L18.2 2zm-1.1 18h1.7L7 3.9H5.2L17.1 20z" />
    </svg>
  );
}

function IconTikTok() {
  return (
    <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" aria-hidden="true">
      <path d="M19.6 7.1a6.3 6.3 0 0 1-3.7-1.2v8.1a5.9 5.9 0 1 1-5.1-5.8v2.8a3.1 3.1 0 1 0 2.3 3V2h2.8a6.3 6.3 0 0 0 3.7 3.6v1.5z" />
    </svg>
  );
}

function IconFacebook() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
      <path d="M14 9h3V6h-3c-2.2 0-4 1.8-4 4v2H7v3h3v7h3v-7h3l1-3h-4v-2c0-.6.4-1 1-1z" />
    </svg>
  );
}

function IconKick() {
  return (
    <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" aria-hidden="true">
      <path d="M3 3h5.2v6.2L14.5 3H21l-7.1 7.4L21 21h-6.6l-6.2-7.8V21H3V3z" />
    </svg>
  );
}

function IconDiscord() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
      <path d="M19.3 5.1A17 17 0 0 0 14.9 4l-.2.4c1.5.3 2.9.9 4.2 1.6A13.6 13.6 0 0 0 5.1 5.6c1.3-.7 2.7-1.3 4.2-1.6L9.1 4A17 17 0 0 0 4.7 5.1C2.4 8.6 1.7 11.9 2 15.2a17.2 17.2 0 0 0 5.2 2.7l.7-1.1a10.9 10.9 0 0 1-1.6-.8l.4-.3c3 .1 5.9.1 8.8 0l.4.3c-.5.3-1 .6-1.6.8l.7 1.1a17.2 17.2 0 0 0 5.2-2.7c.4-3.9-.6-7.2-2.9-10.1zM9.1 13.6c-.9 0-1.6-.8-1.6-1.8s.7-1.8 1.6-1.8 1.7.8 1.6 1.8-.7 1.8-1.6 1.8zm5.8 0c-.9 0-1.6-.8-1.6-1.8s.7-1.8 1.6-1.8 1.7.8 1.6 1.8-.7 1.8-1.6 1.8z" />
    </svg>
  );
}

function IconLastFm() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true">
      <path d="M10.6 17.2c-1.9.4-2.9-.4-3.1-1.8-.2-1.3.5-2.1 1.9-2.3l1.6-.3c1.9-.3 3.1-1.3 3.1-3.1 0-2-1.6-3.3-4.2-3.3-2.5 0-4.1 1.1-4.4 3.1l2.3.3c.2-.9.8-1.4 2-1.4 1.1 0 1.7.5 1.7 1.3 0 .8-.5 1.2-1.8 1.4l-1.5.3c-2.6.5-3.9 1.7-3.9 3.9 0 2.4 1.7 3.8 4.6 3.8 2.2 0 3.9-.7 4.7-2.2l-2.1-.9c-.4.9-1.3 1.4-2.9 1.4zm9.1-1.1c-.8 1.5-2.1 2.3-3.8 2.3-1.9 0-3.2-1-3.2-2.6 0-1.6 1.1-2.5 3.3-3l1.3-.3c1-.2 1.4-.6 1.4-1.2 0-.7-.6-1.1-1.6-1.1-1.1 0-1.8.5-2 1.4l-2.2-.4c.4-2 2.1-3.1 4.4-3.1 2.4 0 4 1.2 4 3.2 0 1.1-.5 2-1.6 2.5l-1.5.5c-1 .3-1.4.6-1.4 1.2 0 .7.6 1.1 1.6 1.1.9 0 1.6-.4 2-1.2l2.3.8z" />
    </svg>
  );
}

const ICONS = {
  website: IconWebsite,
  youtube: IconYouTube,
  twitch: IconTwitch,
  instagram: IconInstagram,
  twitter: IconTwitter,
  x: IconTwitter,
  tiktok: IconTikTok,
  facebook: IconFacebook,
  kick: IconKick,
  discord: IconDiscord,
  lastfm: IconLastFm,
  'last.fm': IconLastFm,
};

function displayLabel(link, kind) {
  if (link?.label) return link.label;
  if (kind === 'website') return 'Official website';
  if (kind === 'twitter') return 'X';
  return kind.charAt(0).toUpperCase() + kind.slice(1);
}

/**
 * Official website + socials as icon badges (not text links).
 */
export default function HubLinkBadges({ links = [], className = '' }) {
  const items = (links || []).filter((l) => l?.url);
  if (!items.length) return null;

  return (
    <div className={`entity-hub-link-badges${className ? ` ${className}` : ''}`}>
      {items.map((link) => {
        const kind = normalizeKind(link);
        const Icon = ICONS[kind] || IconWebsite;
        const label = displayLabel(link, kind);
        return (
          <a
            key={`${kind}-${link.url}`}
            className={`entity-hub-link-badge entity-hub-link-badge--${kind}`}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            title={label}
            aria-label={label}
          >
            <Icon />
          </a>
        );
      })}
    </div>
  );
}
